import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native-web";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faDice } from "@fortawesome/free-solid-svg-icons";
import styles from "./styles";
import MainPage from "./mainPage";  // Import the MainPage component
import AnalyticsPage from "./analyticsPage";

const App = () => {
  const [hoverChart, setHoverChart] = useState(false);
  const [hoverDice, setHoverDice] = useState(true); // Set default dice to active
  const [showDiceContent, setShowDiceContent] = useState(true); // Toggle content display

  // Style for active icon
  const iconStyle = (isActive) => ({
    color: isActive ? '#f39c12' : 'black',  // Highlight yellow if active
  });

  return (
    <View>
      <View style={styles.headerContainer}>
        <View style={styles.heading}>
          <Text style={styles.headingText}>Word Squirm</Text>
        </View>

        <TouchableOpacity
          style={[styles.icon, hoverDice ? styles.iconHover : {}]}
          onMouseEnter={() => setHoverDice(true)}
          onMouseLeave={() => setHoverDice(false)}
          onPress={() => {
            setShowDiceContent(true); // Show dice content on click
          }}
        >
          <FontAwesomeIcon 
            icon={faDice} 
            style={iconStyle(showDiceContent)}  // Apply highlight if active
          />
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.icon, hoverChart ? styles.iconHover : {}]}
          onMouseEnter={() => setHoverChart(true)}
          onMouseLeave={() => setHoverChart(false)}
          onPress={() => {
            setShowDiceContent(false); // Show chart content on click
          }}
        >
          <FontAwesomeIcon 
            icon={faChartLine} 
            style={iconStyle(!showDiceContent)}  // Apply highlight if active
          />
        </TouchableOpacity>
        
      </View>

      {/* Conditionally render content based on the selected icon */}
      <View style={styles.contentContainer}>
        {showDiceContent ? <MainPage /> : <AnalyticsPage />} 
      </View>
    </View>
  );
};

export default App;
